// import moment from 'moment';
import _ from 'lodash';

import { createAction } from 'redux-actions';

import SwaggerAPI from 'data/SwaggerAPI';

const SET_SELECTED_ORGANIZATION = 'organizations/SET_SELECTED_ORGANIZATION';
const REQUEST_ORGANIZATIONS = 'organizations/REQUEST_ORGANIZATIONS';
const RECEIVE_ORGANIZATIONS = 'organizations/RECEIVE_ORGANIZATIONS';
const UPDATE_ORGANIZATION = 'organizations/UPDATE_ORGANIZATION';
const CREATE_ORGANIZATION = 'organizations/CREATE_ORGANIZATION';

const initialState = {
  isFetchingOrganizations: false,
  selectedOrganization: {},
  organizations: [],
  initialized: false,
  error: undefined,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_ORGANIZATION: {
      if (action.organizationId === state.selectedOrganization.id) return state;
      let newOrg = _.clone(state.selectedOrganization);
      if (action.organizationId) {
        const org = _.find(state.organizations, { id: action.organizationId });
        if (!org) {
          return {
            ...state,
            selectedOrganization: Object.assign({}, { id: action.organizationId }),
          };
        }

        const { id, created_at, updated_at, name, audience } = org;
        return {
          ...state,
          selectedOrganization: Object.assign({}, newOrg, { id, created_at, updated_at, name, audience }),
        };
      } else {
        return { ...state, selectedOrganization: {} };
      }
    }

    case REQUEST_ORGANIZATIONS: {
      return { ...state, initialized: true, isFetchingOrganizations: true };
    }
    case RECEIVE_ORGANIZATIONS: {
      if (!action.payload) return state;

      let organizations;

      if (action.payload.length >= 1) {
        organizations = action.payload;
      }
      // XXX Set the center location point of the fields with turf.js

      return {
        ...state,
        organizations,
        isFetchingOrganizations: false,
      };
    }

    case UPDATE_ORGANIZATION: {
      const props = [...state.organizations];
      const index = _.findIndex(props, { id: action.payload.id });
      if (index !== -1) {
        props[index] = action.payload;
      }
      return {
        ...state,
        organizations: props,
        isFetchingOrganizations: false,
      };
    }
    case CREATE_ORGANIZATION: {
      if (action.error) {
        return state;
      }

      const props = [...state.organizations];

      props.push(action.payload);

      return {
        ...state,
        organizations: props,
        selectedOrganization: action.payload.id,
        isFetchingOrganizations: false,
      };
    }
    default:
      return state;
  }
};

const Organizations = (function () {
  const setSelectedOrganization = (organizationId) => ({ type: SET_SELECTED_ORGANIZATION, organizationId });
  const startFetch = () => ({ type: REQUEST_ORGANIZATIONS });
  const fetchOrganizations = createAction(RECEIVE_ORGANIZATIONS, SwaggerAPI.organizationList); // TeralyticAPI.getProperties);

  const getIsFetchingOrganizations = (state) => state.organizations.isFetchingOrganizations;
  const getActiveOrganizationId = (state) => state.organizations.selectedOrganization?.id;
  const getOrganizations = (state) => state.organizations.organizations;
  const updateOrganization = createAction(UPDATE_ORGANIZATION, SwaggerAPI.organizationUpdate);
  const createOrganization = createAction(CREATE_ORGANIZATION, SwaggerAPI.organizationCreate);

  const getActiveOrganization = (state) => state.organizations.selectedOrganization;

  return {
    setSelectedOrganization,
    getIsFetchingOrganizations,
    startFetch,
    fetchOrganizations,
    getActiveOrganizationId,
    getActiveOrganization,
    getOrganizations,
    updateOrganization,
    createOrganization,
  };
})();

export default Organizations;
